import React from "react";
import FullScreenSection from "./FullScreenSection";
import { Box, Heading } from "@chakra-ui/react";
import Card from "./Card";

const projects = [
  {
    title: "Lucky Shrub Website",
    description:
      " A peer-review project using software development tools like HTML, CSS & Bootstrap to build attractive web pages and structured semantic data to control how websites appear to the end user",
    getImageSrc: () => require("../images/LuckyShrub.png"),
    url: "https://github.com/RaiSaw/Html-CSS-Project"
  },
  {
    title: "Art Portfolio",
    description:
      " An art portfolio created with simple responsive layout, animations & interactive particle system using HTML canvas element, CSS, vanilla Javascript & Bootstrap",
    getImageSrc: () => require("../images/ArtPortfolio.png"),
    url:"https://github.com/RaiSaw/RaiSketchworld"
  },
  {
    title: "Lil Lemon Reserve-A-Table Mockup",
    description:
      " A peer-review project using UX insights, creating a user persona & wireframe for features in Figma & turning into Minimum Viable Product (MVP) style prototype from mockup",
    getImageSrc: () => require("../images/LilLemon.png"),
    url: "https://www.figma.com/file/srtpiFJO9HljMVsD6Fzeza/Prototype_LL?t=iXW64TKsgDIX3kNL-0"
  },
  {
    title: "Lil Lemon Reserve-A-Table App",
    description:
      " A capstone project created using React covering usability, accessibility and responsive design",
    getImageSrc: () => require("../images/Lil-Lemon.png"),
    url:"https://github.com/RaiSaw/Lil-Lemon-App"
  },
  {
    title: "R3F Portal Well Scene",
    description:
      " An interactive scene created using react-three-fiber, a react renderer for three.js, integrating tools/ helpers (Drei), react post-processing, 3D models & shaders",
    getImageSrc: () => require("../images/Scene.png"),
    url:"https://github.com/RaiSaw/R3F-Scene"
  },
  {
    title: "bynd Art Gallery Website",
    description:
      " A website skills project created using Javascript and React framework demonstrating essential Javascript and React concepts",
    getImageSrc: () => require("../images/bynd.png"),
    url:"https://github.com/RaiSaw/bynd_Art"
  }
];
/*  */
const ProjectsSection = () => {
  return (
    <FullScreenSection
      backgroundColor="#14532d"
      isDarkBackground
      p={8}
      alignItems="flex-start"
      spacing={8}
      maxWidth="1280px"
      w='100%'
      className="projects"
    >
      <Heading as="h1" id="projects-section" >
        Featured Projects
      </Heading>
      <Box
        display="grid"
        gridTemplateColumns="repeat(2,minmax(0,1fr))"
        gridGap={8}
      >
        {projects.map((project) => (
          <Card
            key={project.title}
            title={project.title}
            description={project.description}
            imageSrc={project.getImageSrc()}
            url={project.url}
          />
        ))}
      </Box>
    </FullScreenSection>
  );
};

export default ProjectsSection;
